import { render, staticRenderFns } from "./PresetItemView.vue?vue&type=template&id=4deeaa90&"
import script from "./PresetItemView.vue?vue&type=script&lang=ts&"
export * from "./PresetItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports